// components/Gacha/GachaBoxDraw.jsx

import {
    Box, Grid, Typography, Chip, Button
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../../api/axios';
import './GachaBoxDraw.css';
import confetti from 'canvas-confetti';
import { useUser } from '../../contexts/UserContext'; // ✅ 추가

export default function GachaBoxDraw() {
    const navigate = useNavigate();
    const location = useLocation();
    const { category } = location.state || {};
    const { refreshUserInfo } = useUser(); // ✅ 사이드바 포인트 갱신용

    const [isDrawn, setIsDrawn] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [animatingIndex, setAnimatingIndex] = useState(null);
    const [result, setResult] = useState(null);
    const [animateBoxes, setAnimateBoxes] = useState(true);
    const [userPoint, setUserPoint] = useState(0);

    useEffect(() => {
        if (!category) {
            navigate('/main/gacha/luckybox');
        }

        // 유저 포인트 불러오기
        api.get('/api/user-info/')
            .then(res => {
                setUserPoint(res.data.points || 0);
            });
    }, [category, navigate]);

    const triggerAnimationThenDraw = (index) => {
        if (isDrawn || animatingIndex !== null) return;

        setAnimatingIndex(index);
        setTimeout(() => {
            setAnimatingIndex(null);
            handleBoxSelect(index);
        }, 1400);
    };

    const handleBoxSelect = async (index) => {
        setSelectedIndex(index);
        setIsDrawn(true);

        try {
            const res = await api.post('/api/gacha/luckybox/draw/', {
                category: category.tier,
                box_index: index,
            });
            setResult(res.data);

            if (!res.data.is_duplicate) {
                confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 } });
                setTimeout(() => {
                    confetti({ particleCount: 100, spread: 90, origin: { y: 0.5 } });
                }, 300);
                setTimeout(() => {
                    confetti({ particleCount: 150, spread: 110, origin: { y: 0.4 } });
                }, 600);
            }

            setUserPoint(res.data.remaining_points || userPoint);
            await refreshUserInfo(); // ✅ 사이드바 포인트 갱신

        } catch (err) {
            alert('뽑기 실패: ' + (err.response?.data?.error || err.message));
        }
    };

    const handleReset = () => {
        setIsDrawn(false);
        setSelectedIndex(null);
        setAnimatingIndex(null);
        setResult(null);

        setAnimateBoxes(false);
        requestAnimationFrame(() => setAnimateBoxes(true));
    };

    const getBoxClass = (idx) => {
        if (animatingIndex === idx) return 'shake-decrease';
        if (animateBoxes) return 'pop-in';
        return '';
    };

    const getBoxStyle = (idx) => {
        if (animateBoxes && animatingIndex === null) {
            const delay = 0.1 * idx;
            return { animationDelay: `${delay}s` };
        }
        return {};
    };

    const getBoxImage = (idx) => {
        if (!isDrawn) return '/images/box-closed.png';
        if (idx === selectedIndex) return '/images/box-open-win.png';
        return '/images/box-open-empty.png';
    };

    const price = category?.price ?? 0;

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" align="center">
                {category?.name} 🎁 럭키 박스 뽑기 🎁
            </Typography>

            <Typography variant="body2" align="center" sx={{ mb: 3 }}>
                가격: {price.toLocaleString()} Leaf🌿 / 보유: {userPoint.toLocaleString()} Leaf🌿
            </Typography>

            <Grid container spacing={2} justifyContent="center">
                {[0, 1, 2, 3, 4].map((idx) => (
                    <Grid item key={idx}>
                        <Box
                            component="img"
                            src={getBoxImage(idx)}
                            alt={`Box ${idx + 1}`}
                            onClick={() => !isDrawn && triggerAnimationThenDraw(idx)}
                            className={getBoxClass(idx)}
                            style={getBoxStyle(idx)}
                            sx={{
                                width: 100,
                                height: 100,
                                cursor: isDrawn ? 'default' : 'pointer',
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: !isDrawn ? 'scale(1.05)' : 'none',
                                },
                            }}
                        />
                    </Grid>
                ))}
            </Grid>

            {result && (
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        🎉 획득한 칭호: {result.title_name}
                    </Typography>
                    <Chip
                        label={result.tier}
                        color={result.tier_color || 'default'}
                        sx={{ fontSize: '1rem' }}
                    />
                    {result.is_duplicate && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            이미 보유한 칭호입니다.
                        </Typography>
                    )}
                    <Button variant="outlined" sx={{ mt: 2 }} onClick={handleReset}>
                        다시 뽑기
                    </Button>
                </Box>
            )}

            {!isDrawn && (
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Button variant="text" onClick={() => navigate('/main/gacha/luckybox')}>
                        돌아가기
                    </Button>
                </Box>
            )}
        </Box>
    );
}
